import type { Property } from "csstype";
import type { ReactNode } from "react";

export interface TagProps {
  text?: string;
  children?: ReactNode;
  /** hex rgb color */
  backgroundColor: string;
  textColor?: string;
  /** 0-1 */
  opacity?: number;
  fontSize?: Property.FontSize;
  className?: string;
  paddingX?: string;
  paddingY?: string;
}

export function Tag({
  text,
  children,
  backgroundColor,
  textColor = "#fff",
  opacity = 0.8,
  fontSize = "1em",
  className = "",
  paddingX = "0.6em",
  paddingY = "0.2em",
}: TagProps) {
  return (
    <div
      className={className}
      style={{
        background: `rgb(from ${backgroundColor} r g b / ${opacity})`,
        padding: `${paddingY} ${paddingX}`,
        borderRadius: "0.3em",
        color: textColor,
        display: "inline-flex",
        alignItems: "center",
        gap: "0.4em",
        fontSize,
      }}
    >
      {text && <span>{text}</span>}
      {children}
    </div>
  );
}